module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profession":"Software developer","pic":"Background image by","prep":"from","pixabay":"Pixabay"},"fi":{"profession":"Sovelluskehittäjä","pic":"Taustakuva","prep":" ","pixabay":"Pixabaystä"}}')
  delete Component.options._Ctor
}
